module.exports = __webpack_public_path__ + "static/media/Session_Expired_Image@3x.cb99f33a.png";